import { render } from "./VoucherManage.vue?vue&type=template&id=a6f6acee"
import script from "./VoucherManage.vue?vue&type=script&lang=js"
export * from "./VoucherManage.vue?vue&type=script&lang=js"
script.render = render

export default script